<span class="dvb-rechnungsbetrag-display">
    <span data-translate="{{vm.translationKey}}" data-translate-value-betrag="{{vm.rechnungsempfaenger.value}}"></span>
</span>
